// FieldVision - ZoneLegend.tsx
// Legend boks der viser zone-farver med l/ha vaerdier
// Positioneret i nederste hoejre hjoerne af kortet
// FIX 2025-12-30: Øget margin fra kant (30px i stedet for 20px)

import React from 'react';
import { ZoneData } from './zones/ZoneRow';

interface ZoneLegendProps {
  zones: ZoneData[];
  zoneColors: Record<number, string>;
  mapType?: string;
}

const ZoneLegend: React.FC<ZoneLegendProps> = ({
  zones,
  zoneColors,
  mapType = 'NDVI'
}) => {
  // Filtrer zone 0 og sorter
  const activeZones = zones
    .filter(z => z.zone !== 0)
    .sort((a, b) => a.zone - b.zone);

  if (activeZones.length === 0) {
    return null;
  }

  const getTypeLabel = (type: string) => {
    switch (type?.toLowerCase()) {
      case 'ndvi':
        return 'NDVI ZONER';
      case 'weed':
        return 'UKRUDT ZONER';
      case 'regrowth':
        return 'GENVAEKST ZONER';
      default:
        return 'ZONER';
    }
  };

  const unit = activeZones[0]?.unit || 'l/ha';

  return (
    <div className="map-legend">
      <h4 className="legend-title">{getTypeLabel(mapType)}</h4>
      <div className="legend-items">
        {activeZones.map(zone => (
          <div key={zone.zone} className="legend-item">
            <div
              className="legend-color"
              style={{ backgroundColor: zoneColors[zone.zone] || '#9ca3af' }}
            />
            <span className="legend-label">Zone {zone.zone}</span>
            <span className="legend-value">{Math.round(zone.rate)} {unit}</span>
          </div>
        ))}
      </div>

      <style>{`
        .map-legend {
          position: absolute;
          bottom: 30px;
          right: 30px;
          background: white;
          border-radius: 12px;
          padding: 15px;
          box-shadow: 0 4px 15px rgba(0, 0, 0, 0.15);
          min-width: 150px;
          z-index: 400;
        }

        .legend-title {
          margin: 0 0 12px 0;
          font-size: 11px;
          font-weight: 600;
          color: #6b7280;
          text-transform: uppercase;
          letter-spacing: 0.5px;
        }

        .legend-items {
          display: flex;
          flex-direction: column;
          gap: 8px;
        }

        .legend-item {
          display: flex;
          align-items: center;
          gap: 10px;
        }

        .legend-color {
          width: 16px;
          height: 16px;
          border-radius: 4px;
          flex-shrink: 0;
        }

        .legend-label {
          font-size: 13px;
          color: #374151;
          flex: 1;
        }

        .legend-value {
          font-size: 13px;
          font-weight: 600;
          color: #111827;
        }

        /* Responsive: mindre legend paa smalle skaerme */
        @media (max-width: 768px) {
          .map-legend {
            bottom: 16px;
            right: 16px;
            padding: 12px;
            min-width: 130px;
          }

          .legend-title {
            font-size: 10px;
            margin-bottom: 8px;
          }

          .legend-items {
            gap: 6px;
          }

          .legend-color {
            width: 14px;
            height: 14px;
          }

          .legend-label,
          .legend-value {
            font-size: 12px;
          }
        }
      `}</style>
    </div>
  );
};

export default ZoneLegend;
